import { createSlice } from "@reduxjs/toolkit";
import {
  getUserDetails,
  getUserTotalCoins,
  getProfileOrderAndServicesCountBadges,
} from "../actions/User.action";

const initialLog = {
  type: "",
  error: false,
  message: null,
  loading: false,
  success: false,
};

const initialState = {
  loading: false,
  token: null,
  success: false,
  message: null,
  data: null,
  totalCoins: 0,
  profileOrdersCount: {
    productOrders: 0,
    servicesBooked: 0,
  },
  logs: initialLog,
};

const slice = createSlice({
  name: "User",
  initialState,
  reducers: {
    saveToken: (state, action) => {
      state.token = action.payload;
    },
    resetAuthToken: (state) => {
      state.token = null;
    },
    resetState: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = null;
      state.token = null;
      state.data = null;
      state.totalCoins = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        const data = action.payload.d;
        const fullName = data.firstName + " " + data.lastName;

        state.loading = false;
        state.data = data;
        state.data.fullName = fullName;
        state.error = false;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.error = true;
        state.message = action?.payload?.m;
        console.log("getUserDetails:", action);
      })
      .addCase(getProfileOrderAndServicesCountBadges.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getProfileOrderAndServicesCountBadges",
        };
      })
      .addCase(
        getProfileOrderAndServicesCountBadges.fulfilled,
        (state, action) => {
          state.profileOrdersCount = action.payload.d;
          state.logs = { ...state.logs, success: true, loading: false };
        }
      )
      .addCase(
        getProfileOrderAndServicesCountBadges.rejected,
        (state, action) => {
          state.logs = {
            ...state.logs,
            loading: false,
            error: action?.payload?.errors,
            message:
              action.payload?.m ||
              "Something went wrong getting orders and services count.",
          };
        }
      )
      // ========= GET USER TOTAL COINS ==========
      .addCase(getUserTotalCoins.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getUserTotalCoins.fulfilled, (state, action) => {
        state.loading = false;
        state.totalCoins = action.payload?.d.totalCoins;
        state.error = false;
      })
      .addCase(getUserTotalCoins.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { reducer: User } = slice;

export const saveAuthToken = (payload) => (dispatch) => {
  dispatch(slice.actions.saveToken(payload));
};

export const resetAuthToken = () => (dispatch) => {
  dispatch(slice.actions.resetAuthToken());
};

export const resetUserState = () => (dispatch) => {
  dispatch(slice.actions.resetState());
};

export default slice;
